import service from 'service';

export const getTotalMsgs = () => {
  const url = '/core_messaging/v1/dashboard/total';
  return service.get(url);
};

export const getTotalOrgs = () => {
  const url = '/core_subscriber/organization/total';
  return service.get(url);
};

export const getTotalInteg = () => {
  const url = '/core_keys/v1/token/total';
  return service.get(url);
};

export const getTotalMasks = () => {
  const url = '/core_sender/v1/sender_name/total';
  return service.get(url);
};

export const getDashboardGraph = ({ queryKey: [, params] }) => {
  const url = '/core_messaging/v1/dashboard/graph';
  return service.get(url, { params });
};

export const getTopTenSubs = ({ queryKey: [, params] }) => {
  const url = '/core_wallet/v1/wallet_ledger/top_subscriber';
  return service.get(url, { params });
};

export const getTotalTxnAndCol = () => {
  const url = '/core_wallet/v1/wallet_ledger/total_collection';
  return service.get(url);
};

export const getTopMaskNames = ({ queryKey: [, params] }) => {
  const url = '/core_messaging/v1/dashboard/bar';
  return service.get(url, { params });
};

export const getSmsGraph = ({ queryKey: [, params] }) => {
  const url = '/core_messaging/v1/dashboard/graph';
  return service.get(url, { params: { ...params, channel: 'sms' } });
};

export const getPushGraph = ({ queryKey: [, params] }) => {
  const url = '/core_messaging/v1/dashboard/graph';
  return service.get(url, { params: { ...params, channel: 'push' } });
};

export const getEmailGraph = ({ queryKey: [, params] }) => {
  const url = '/core_messaging/v1/dashboard/graph';
  return service.get(url, { params: { ...params, channel: 'email' } });
};

export const getRecentMessages = ({ queryKey: [, params] }) => {
  const url = '/core_messaging/v1/report';
  return service.get(url, { params });
};
